/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * Determines whether an item should be moved during a drag and drop operation.
 * @param {DOMRect} hoverBoundingRect - The bounding rectangle of the hovered item.
 * @param {XYCoord | null} clientOffset - The client offset of the cursor.
 * @param {number} dragIndex - The index of the item being dragged.
 * @param {number} hoverIndex - The index of the hovered item.
 * @returns {boolean} - Returns true if the item should be moved, otherwise false.
 */
export function shouldMove (hoverBoundingRect, clientOffset, dragIndex, hoverIndex) {
    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%

    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return false;
    }

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return false;
    }

    return true;
}
